import { F } from "@/components/sheets/SheetFrame";

export function placeLabels(labels, ox, oy, ks, top, bottom, ts) {
  const pts = labels.map((l) => ({ ...l, sx: ox + l.x / ks, sy: oy + l.y / ks })).sort((a, b) => a.sy - b.sy);
  let prev = top;
  const placed = pts.map((p) => { const ty = Math.max(p.sy + 0.8, prev + ts * 1.35); prev = ty; return { ...p, ty }; });
  const overflow = prev - bottom;
  if (overflow > 0) placed.forEach((p) => { p.ty -= overflow; });
  placed.forEach((p, j) => { if (j > 0 && p.ty < placed[j - 1].ty + ts * 1.35) p.ty = placed[j - 1].ty + ts * 1.35; });
  return placed;
}

export const Leaders = ({ placed, labelX, ts, max = 44 }) => placed.map((p, j) => (
  <g key={j}>
    <circle cx={p.sx} cy={p.sy} r={0.45} fill="#B45309" />
    <polyline points={`${p.sx},${p.sy} ${labelX - 4},${p.ty - 0.7} ${labelX - 1},${p.ty - 0.7}`} fill="none" stroke="#B45309" strokeWidth={0.15} />
    <text x={labelX} y={p.ty} fontSize={ts} fill="#000" fontFamily={F}>{p.text.slice(0, max)}</text>
  </g>
));
